import { cn } from '@/lib/utils';

export interface ToolSectionNavItem {
  id: string;
  label: string;
}

interface ToolSectionNavProps {
  items: ToolSectionNavItem[];
  activeId: string | null;
  onSelect: (id: string) => void;
}

export const ToolSectionNav = ({ items, activeId, onSelect }: ToolSectionNavProps) => {
  if (items.length <= 1) return null;

  return (
    <div className="sticky top-0 z-10 border-b border-domino-cardBorder bg-domino-warm/95 backdrop-blur supports-[backdrop-filter]:bg-domino-warm">
      <div className="flex gap-2 overflow-x-auto px-5 py-3 lg:px-6">
        {items.map((item) => {
          const isActive = activeId === item.id;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item.id)}
              className={cn(
                'shrink-0 border-b-2 px-1 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-domino-aubergine text-domino-ink'
                  : 'border-transparent text-domino-inkSoft hover:text-domino-ink'
              )}
            >
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
